<template>
    <!-- 活动--定点投放--投放统计 -->
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">渠道码编号:</span>
                        <!-- 搜索编码 -->
                        <el-input
                            v-model="search_data.promotion_qr_code"
                            placeholder="请输入编码"
                            class="handle-input mr10 promotion_qr_code"
                            @keyup.enter.native="searchStatisticPromotion"
                        ></el-input>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">渠道码名称:</span>
                        <!-- 搜索渠道码名称 -->
                        <el-input
                            v-model="search_data.name"
                            placeholder="请输入渠道码名称"
                            class="handle-input mr10 promotion_qr_code"
                            @keyup.enter.native="searchStatisticPromotion"
                        ></el-input>
                    </el-col>
                </el-row>
                <el-row class="head-search">
                    <span class="title">投放时间:</span>
                    <el-date-picker
                        v-model="search_time"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        @change="timeChange"
                        style="width: 330px"
                    >
                    </el-date-picker>
                </el-row>
            </div>

            <el-button type="primary" icon="el-icon-search" @click="searchStatisticPromotion">搜索</el-button>
            <el-button type="primary" @click="getOverViewBtn">投放概览</el-button>

            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column label="渠道码名称" prop="name"> </el-table-column>
            <el-table-column label="投放类目" prop="promotion_category_name"> </el-table-column>
            <el-table-column label="投放时间" prop="market_time"> </el-table-column>

            <el-table-column label="扫码量(新客)" prop="new_order_num" min-width="40"> </el-table-column>
            <el-table-column label="扫码量(老客)" prop="old_order_num" min-width="40"> </el-table-column>
            <el-table-column label="下单量" prop="order_num" min-width="40"> </el-table-column>
            <el-table-column label="渠道码编号" prop="promotion_qr_code" min-width="100"> </el-table-column>
            <!-- <el-table-column label="扫码次数" prop="scan_num" min-width="130"> </el-table-column> -->
            <el-table-column label="订单总金额" prop="total_amount" min-width="40"> </el-table-column>
            <el-table-column width="100px" label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" trigger="click" @click="details(scope.row)"> 查看 </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 查看组件 -->
        <getView :isShow="view_isShow" :data="viewData"></getView>

        <!-- 投放概览组件 -->
        <getOverView :isShow="tou_isShow" :data="gaiLanData"></getOverView>
    </div>
</template>

<script>
var _this;
import getView from './getView.vue';
import getOverView from './getOverView.vue';

export default {
    components: {
        getView,
        getOverView
    },

    data() {
        return {
            tou_isShow: false,
            gaiLanData: {},
            search_time: '',
            view_isShow: false,
            viewData: '',

            // 存放表格数据
            tableData: [],

            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                name: '',
                promotion_qr_code: '',
                fixed_array: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.searchStatisticPromotion();
    },

    methods: {
        getOverViewBtn() {
            console.log('点击列表页面投放概览');

            _this.gaiLanData.promotion_category_code = '';
            _this.gaiLanData.promotion_qr_code = '';
            _this.gaiLanData.district = '';

            _this.tou_isShow = !_this.tou_isShow;
        },
        details(e) {
            console.log(e,'投放统计查看');
            _this.viewData = e;
            _this.view_isShow = !_this.view_isShow;
        },
        timeChange(val) {
            console.log(val);

            if (val != null) {
                _this.search_data.fixed_array = JSON.stringify(['between', ..._this.search_time]);
            } else {
                _this.search_data.fixed_array = '';
            }
        },

        searchStatisticPromotion() {
            _this.search_data.page = 1;
            _this.statisticPromotion();
        },

        statisticPromotion() {
            _this
                .$post('/promotion/statisticPromotion', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.statisticPromotion();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
<style>
.promotion_qr_code .el-input__inner {
    width: 330px;
}
</style>
